module.exports = __webpack_public_path__ + "img/player.c69f3dea.png";